import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { LogoLockup } from '../logo/LogoLockup';
import { LinkButton } from '../button/Button';
import { NavMenuDesktop } from './NavMenuDesktop';
import { NavMenuMobile } from './NavMenuMobile';
import chevronSvg from '../../assets/angle-down.svg';
import './Navbar.scss';
import './NavMenu.scss';
var LinksButton = function LinksButton(_ref) {
  var onClick = _ref.onClick,
    open = _ref.open;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: classNames('nav-links', {
      open: open
    })
  }, /*#__PURE__*/React.createElement("span", null, "How people use Milanote"), " ", /*#__PURE__*/React.createElement("img", {
    src: chevronSvg,
    alt: ""
  }));
};
var LinksMenu = function LinksMenu(_ref2) {
  var segments = _ref2.segments,
    open = _ref2.open,
    setOpen = _ref2.setOpen;
  return /*#__PURE__*/React.createElement("div", {
    className: "LinksMenu"
  }, /*#__PURE__*/React.createElement(LinksButton, {
    onClick: function onClick() {
      return setOpen(function (open) {
        return !open;
      });
    },
    open: open
  }), /*#__PURE__*/React.createElement(NavMenuDesktop, {
    segments: segments,
    open: open
  }));
};
var NavActionsDesktop = function NavActionsDesktop(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement(LinksMenu, props), /*#__PURE__*/React.createElement(LinkButton, {
    href: "https://app.milanote.com/"
  }, "Log in"), /*#__PURE__*/React.createElement(LinkButton, {
    href: "#signup-form",
    cta: true
  }, "Sign up for free"));
};
export var Navbar = function Navbar(_ref3) {
  var segments = _ref3.segments;
  var threshold = 30;
  var ref = useRef();
  useEffect(function () {
    var abortController = new AbortController();
    document.addEventListener('scroll', function () {
      var shouldShowFade = window.scrollY > threshold;
      ref.current.classList.toggle('scrolled', shouldShowFade);
    }, {
      signal: abortController.signal
    });
    return function () {
      abortController.abort();
    };
  }, []);

  // Menu open-close logic -- shared between desktop & mobile
  // (really only relevant if you resize the window while the menu is open, but it might happen)
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  useEffect(function () {
    if (!menuOpen) return;
    var abortController = new AbortController();
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      setMenuOpen(false);
    }, {
      signal: abortController.signal
    });
    return function () {
      abortController.abort();
    };
  }, [menuOpen]);
  return /*#__PURE__*/React.createElement("nav", {
    className: "Navbar",
    ref: ref
  }, /*#__PURE__*/React.createElement(LogoLockup, null), menuOpen && /*#__PURE__*/React.createElement("div", {
    className: "overlay",
    onClick: function onClick() {
      return setMenuOpen(false);
    }
  }), /*#__PURE__*/React.createElement(NavActionsDesktop, {
    segments: segments,
    open: menuOpen,
    setOpen: setMenuOpen
  }), /*#__PURE__*/React.createElement(NavMenuMobile, {
    segments: segments,
    open: menuOpen,
    setOpen: setMenuOpen
  }));
};